import { useTranslation } from 'react-i18next'
import { Main } from '../../components'

interface Props {
  nested?: boolean
  message?: string
}

const NotFound = ({ message, nested }: Props) => {
  const { t } = useTranslation()

  const ErrorContent = (
    <div className='text-center mt-16'>
      <h3>{t('errors.not_found')}</h3>
      <p>{message}</p>
    </div>
  )

  if (nested) {
    return ErrorContent
  } else {
    return <Main>{ErrorContent}</Main>
  }
}

export default NotFound
